// extracted by mini-css-extract-plugin
export var arrow = "_3m-6";
export var changeItem = "_3m-3";
export var changesHeader = "_3m-1";
export var changesList = "_3m-2";
export var container = "_3m-0";
export var pathLabel = "_3m-4";
export var value = "_3m-7";
export var valuesContainer = "_3m-5";